import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import moment from "moment";
import "./erxPreviewContainerView.scss";
import ErxPreviewContainerHeaderView from "./ErxPreviewContainerHeaderView/index.js";
import ErxHtmlRenderSettingView from "./ErxHtmlRenderSettingView/index.js";
import {
  GET_PRESCRIPTION_FOR_PREVIEW,
  GET_PRESCRIPTION_PREVIEW,
  GET_PREVIEW_PDF,
} from "../ERXViewApiHandler/apiConstants";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import Loader from "../../UI Component/Loader/Loader";
import {
  getFinalChiefComplaintsList,
  getFinalDiagnosisList,
  getFinalInstructionsList,
  getFinalMedicalHistoryList,
  getFinalObstetricCalculatorDetails,
  getFinalObstetricHistoryList,
  getFinalReportList,
  getFinalSuggestedInvestigationsList,
  getFinalVitalList,
} from "../helper";
import { ERX_PREVIEW_SETTINGS } from "../ERXConstants/constants";
import ERXPdfViewConatiner from "../ERXPdfViewContainer/index.js";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler/index.js";
import ComponentSpecificLoader from "../../UI Component/Loader/ComponentSpecificLoader";
import {
  convertToBooleanHelper,
  getDoctorDetails,
  getDoctorFullName,
  getDrugHeaders,
  getFormatedDate,
  getPatientAge,
  getSortedData,
  handleDisplayLeftContent,
} from "../ERXPdfViewContainer/ERXPdfHelper/helper.js";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFViewForC2C from "../ERXPdfViewContainer/PDFViewForC2C/index.js";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const ErxPreviewContainerView = (props) => {
  const {
    appointmentData,
    prescription_id,
    vaccineList,
    pharmacyList,
    defaultPharmacy,
    generalVaccineList,
    includeErx,
    vitalsList,
    updatedGender,
    patient_history_and_complaints,
    followUp,
    followUpDate,
    diagnosisList,
    reportList,
    obstetricHistoryList,
    customSection,
    obstetricDetails,
    doctorSpecialization,
    approveAndShareLoader,
    setAlertMessage,
    allowedObstetricDetailsSpecializations,
    handleClose,
    handleApproveAndShareRX,
    disablePreview,
    appointment_id,
    handleDisablePreview,
    callSuggestedListAPI,
    handleCloseErx,
    handleSharePharmacyBtn,
  } = props;

  const token_id = localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const [htmlTemplate, setHtmlTemplate] = useState({
    languageCode: "",
    isTemplateDefault: false,
    languageCodeAferApiCall: "",
  });

  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Prescription",
    fileType: ".pdf",
  });
  const [alignmentOptions, setAlignmentOptions] = useState(
    JSON.parse(JSON.stringify(ERX_PREVIEW_SETTINGS))
  );
  const [languageButtonLoader, setLanguageButtonLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [slugs, setSlugs] = useState(null);
  const [erxPdfData, setErxPdfData] = useState({});

  const [pdfMainContent, setPdfMainContent] = useState({});
  const [pdfAlignmentOrder, setPdfAlignmentOrder] = useState({});
  const [pdfLanguageSlug, setPdfLanguageSlug] = useState({});

  const [tempBlob, setTempBlob] = useState("");
  const [blobList, setBlobList] = useState([]);
  const [pdfBlob, setPdfBlob] = useState("");
  const [docs, setDocs] = useState("");

  // LifeCycle Methods ===>

  useEffect(() => {
    setLoader(true);
    getPrescriptionForPreview();
  }, []);

  useEffect(() => {
    if (erxPdfData && Object.keys(erxPdfData)?.length !== 0) {
      handlePdfMainContent();
    }
  }, [erxPdfData, pdfAlignmentOrder, pdfLanguageSlug]);

  useEffect(() => {
    setPdfMainContent({ ...erxPdfData, showPdf: false });
  }, [htmlTemplate?.languageCodeAferApiCall]);

  useEffect(() => {
    if (alignmentOptions && alignmentOptions?.length !== 0) {
      let orderObj = {};
      alignmentOptions.forEach((ele) => {
        orderObj[ele.name] = { sort: ele.sort, alignment: ele.alignment };
      });
      setPdfAlignmentOrder({ ...orderObj });
    }
  }, [alignmentOptions]);

  useEffect(() => {
    setPdfLanguageSlug(slugs);
  }, [slugs]);

  useEffect(() => {
    if (tempBlob && pdfMainContent?.showPdf) {
      //getting multiple blob
      let list = [...blobList];
      list.push(tempBlob);
      setBlobList(list);
    }
  }, [tempBlob, pdfMainContent]);

  useEffect(() => {
    if (blobList?.length !== 0) {
      //filtering blob based on the size (copleted data is rendered)
      const final_blob = blobList.reduce((max, curren) =>
        max.size > curren.size ? max : curren
      );
      setPdfBlob(final_blob);
    }
  }, [blobList]);

  useEffect(() => {
    if (pdfBlob) {
      let reader = new FileReader();
      reader.readAsDataURL(pdfBlob);
      reader.onloadend = () => {
        let base64data = reader.result;
        setDocs([
          {
            uri: `${base64data}`,
          },
        ]);
      };
    }
  }, [pdfBlob]);

  //  <===

  // Helper Methods ===>

  const handleLeftRightDisplaySetting = (settings, options, hideLeftRight) => {
    settings.forEach((ele) => {
      ele.alignment = options[ele.name]?.alignment ?? ele.alignment;
      ele.sort = options[ele.name]?.sort ?? ele.sort;
      if (ele.value) {
        let hasData = true,
          list = [];

        if (ele.name === "vitals") {
          list = getFinalVitalList(vitalsList, updatedGender);
        } else if (ele.name === "chiefComplaints") {
          list = getFinalChiefComplaintsList(
            patient_history_and_complaints?.value
          );
        } else if (ele.name === "medicalHistory") {
          list = getFinalMedicalHistoryList(
            patient_history_and_complaints?.value,
            updatedGender
          );
        } else if (ele.name === "suggestedInvestigations") {
          list = getFinalSuggestedInvestigationsList(followUp.value);
        } else if (ele.name === "instructionsAndNotes") {
          list = getFinalInstructionsList(followUp.value);
        } else if (ele.name === "diagnosis") {
          list = getFinalDiagnosisList(diagnosisList?.value);
        } else if (ele.name === "reportsExamination") {
          list = getFinalReportList(reportList?.value);
        } else if (ele.name === "obstetricHistory") {
          list = getFinalObstetricHistoryList(obstetricHistoryList?.value);
          ele.hideSectionInPreview = updatedGender?.toLowerCase() !== "female";
        } else if (ele.name === "followUp") {
          list = followUpDate?.value;
        } else if (ele.name === "obstetricCalculator") {
          list = getFinalObstetricCalculatorDetails(obstetricDetails);

          ele.hideSectionInPreview =
            updatedGender?.toLowerCase() !== "female" ||
            !allowedObstetricDetailsSpecializations.includes(
              doctorSpecialization
            );
        }
        hasData = list.length !== 0 && !hideLeftRight;
        ele.showLeftRightAlignment = hasData;
      }

      if (ele.name.includes("customSection")) {
        let name = Object.keys(customSection?.value)
          .filter((item) => item?.toLowerCase() === ele.name?.toLowerCase())
          .reduce((obj, key) => {
            obj[key] = customSection?.value[key];
            return obj[key];
          }, {});

        ele.title = name?.custom_title;
        ele.hideSectionInPreview = !name?.custom_title;
      }
    });
    let alignmentOrder = settings.sort((a, b) => a.sort - b.sort);

    setAlignmentOptions([...alignmentOrder]);
  };

  const handleHtmlDetailsFromApi = (res) => {
    setHtmlTemplate({
      languageCode: res?.data?.data?.langCode,
      isTemplateDefault: res?.data?.data?.is_default_locale,
      languageCodeAferApiCall: res?.data?.data?.langCode,
    });
    handleLeftRightDisplaySetting(
      alignmentOptions,
      res?.data?.data?.alignment_options ?? {},
      res?.data?.data?.hideLeftRight
    );
  };

  const getVaccineList = () => {
    let pdfVaccines = [];
    vaccineList.forEach((ele) => {
      ele.vaccines.forEach((item) => {
        if (item.prescription_id === prescription_id && item.vaccinated_date) {
          pdfVaccines.push(item);
        }
      });
    });

    generalVaccineList.forEach((ele) => {
      ele.vaccines.forEach((item) => {
        if (item.prescription_id === prescription_id && item.vaccinated_date) {
          pdfVaccines.push(item);
        }
      });
    });

    return pdfVaccines;
  };

  const openPdfViewer = (url) => {
    setLoader(true);
    const presDate = moment().format("DD MMM YYYY");
    fileDetails.fileURL = url;
    fileDetails.fileName = `Prescription_${presDate}`;
    setFileDetails(fileDetails);
    setLoader(false);
  };

  const handlePdfMainContent = async () => {
    let data = JSON.parse(JSON.stringify(erxPdfData));
    data["showDoctorDetails"] = handleShowDoctorDetails();
    data["doctorFullName"] = getDoctorFullName(data?.doctor_profile_details);
    if (data?.patient_age) {
      data["display_age"] = getPatientAge(data?.patient_age);
    }
    if (data?.appointment_date) {
      data.appointment_date = getFormatedDate(data?.appointment_date);
    }
    if (data?.follow_up_date) {
      data.follow_up_date = getFormatedDate(data?.follow_up_date);
    }
    data["sortedData"] = await getSortedData(
      data,
      data.includeInErx,
      pdfAlignmentOrder,
      pdfLanguageSlug
    );
    data["displayLeftContent"] = await handleDisplayLeftContent(
      data["sortedData"]
    );
    data["drugHeader"] = await getDrugHeaders(htmlTemplate?.languageCode);
    data["showPdf"] = true;
    setPdfMainContent({ ...data });
  };

  const handleShowDoctorDetails = () => {
    return getDoctorDetails(
      erxPdfData?.clinic_id,
      erxPdfData?.doctor_hospital_details[0]?.enable_custom_header,
      erxPdfData?.doctor_profile_details?.custom_margins_enabled
    )
      ? true
      : false;
  };

  // <===

  // Actions ===>

  const handleResetSettings = () => {
    let settings = JSON.parse(JSON.stringify(ERX_PREVIEW_SETTINGS));
    setHtmlTemplate({ languageCode: "en", isTemplateDefault: false });
    let options = {};
    settings.forEach((ele) => {
      options[ele.name] = { sort: ele.sort, alignment: ele.alignment };
    });
    handleLeftRightDisplaySetting(settings, options, erxPdfData?.hideLeftRight);
    setLanguageButtonLoader(true);
    let data = {
      langCode: "en",
      is_default_locale: false,
      alignment_options: options,
    };
    handleSaveLanguageAPICall(data);
  };

  // <===

  // Api Calls ===>

  // api call to get language translated values
  const handleSaveLanguageAPICall = (selectedLanguage) => {
    let requestPayload = {
      appointment_id: appointmentData?.appointment_id,
      prescription_id: prescription_id,
      doctor_id: userId,
      clinic_id: clinicId ?? userId,
      ...selectedLanguage,
    };
    const resData = c2cPostApiHandler(GET_PRESCRIPTION_PREVIEW, requestPayload);
    resData.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setSlugs(res?.data?.data);
          setLanguageButtonLoader(false);
          setHtmlTemplate({
            ...htmlTemplate,
            isTemplateDefault: selectedLanguage?.is_default_locale,
            languageCode: selectedLanguage?.langCode,
            languageCodeAferApiCall: selectedLanguage?.langCode,
          });
        }
      }
    });
  };

  // api call to get the prescription preview
  const getPrescriptionForPreview = () => {
    let modifiedVaccineList = getVaccineList();

    let requestPayload = {
      appointment_id: appointmentData?.appointment_id,
      prescription_id: prescription_id,
      includeInErx: {
        ...includeErx,
      },
      vaccine_chart: modifiedVaccineList,
      "authorizer-principal-id": {
        user_id: token_id,
        user_type: "2",
        agent: "web",
      },
    };
    const prescriptionPreviewResponse = c2cPostApiHandler(
      GET_PRESCRIPTION_FOR_PREVIEW,
      requestPayload
    );
    prescriptionPreviewResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        if (res?.data?.data?.doctor_profile_details?.custom_margins_enabled) {
          let leftMargin =
            res?.data?.data?.doctor_profile_details?.custom_margin_dimensions
              ?.rxLeft ?? 0;
          let rightMargin =
            res?.data?.data?.doctor_profile_details?.custom_margin_dimensions
              ?.rxRight ?? 0;

          let sumOfLeftRight = Number(leftMargin) + Number(rightMargin);
          res.data.data["hideLeftRight"] = sumOfLeftRight > 4;
        } else {
          res.data.data["hideLeftRight"] = false;
        }
        handleHtmlDetailsFromApi(res);
        let convertedData = convertToBooleanHelper(res?.data?.data);

        setErxPdfData({ ...convertedData });
        setLoader(false);
      } else {
        setErxPdfData({});
        setLoader(false);
      }
    });
  };

  const getGeneratedPrescriptionPdf = () => {
    !disablePreview && setLoader(true);

    let payload = {
      appointment_id: appointment_id,
      prescription_id: prescription_id,
      patient_id: appointmentData?.patient_id,
      clinic_id: clinicId,
      doctor_id: doctorId,
      langCode: htmlTemplate?.languageCode,
    };
    c2cPostApiHandler(GET_PREVIEW_PDF, payload).then(([res, err]) => {
      if (!err) {
        setLoader(false);
        if (res?.data?.statusCode === 200) {
          !disablePreview && openPdfViewer(res?.data?.url);
          handleDisablePreview && handleDisablePreview();
          callSuggestedListAPI && callSuggestedListAPI();
        }
      } else {
        swal({
          title: "Sorry",
          text: "Prescription could not be downloaded ",
          icon: "warning",
        });
      }
    });
  };

  // <===

  // Display UI ===>

  const renderPreviewMainContent = () => {
    return (
      <div className="erx-html-main-container">
        <div className="erx-html-content">
          {languageButtonLoader && <ComponentSpecificLoader />}
          {window?.innerWidth > 768 ? (
            <ERXPdfViewConatiner
              erxPdfData={erxPdfData}
              lang={htmlTemplate?.languageCodeAferApiCall}
              alignmentOptions={alignmentOptions}
              pdfMainContent={pdfMainContent}
            />
          ) : (
            docs?.length > 0 && (
              <DocViewer
                documents={docs}
                pluginRenderers={DocViewerRenderers}
                style={{
                  width: "100%",
                  //  height: 800,
                }}
                config={{
                  header: {
                    disableHeader: false,
                    disableFileName: false,
                    retainURLParams: false,
                  },
                }}
              />
            )
          )}
        </div>

        <div className="erx-settings-content">
          <ErxHtmlRenderSettingView
            languageButtonLoader={languageButtonLoader}
            htmlTemplate={htmlTemplate}
            pharmacyList={pharmacyList}
            defaultPharmacy={defaultPharmacy}
            alignmentOptions={alignmentOptions}
            setAlertMessage={setAlertMessage}
            setHtmlTemplate={setHtmlTemplate}
            setAlignmentOptions={setAlignmentOptions}
            setLanguageButtonLoader={setLanguageButtonLoader}
            handleSaveLanguageAPICall={handleSaveLanguageAPICall}
            handleResetSettings={handleResetSettings}
            handleApproveAndShareRX={handleApproveAndShareRX}
            url={fileDetails?.fileURL}
            fileName={fileDetails?.fileName}
            fileType={fileDetails?.fileType}
            fileDetails={fileDetails}
            getGeneratedPrescriptionPdf={getGeneratedPrescriptionPdf}
            bucketName={erxPdfData?.pdf_path?.s3_bucket_name}
            rxPath={erxPdfData?.pdf_path?.rx_path}
            erxPdfData={erxPdfData}
            lang={htmlTemplate?.languageCode}
            pdfMainContent={pdfMainContent}
            pdfPath={erxPdfData?.pdf_path?.rx_path}
            handleSharePharmacyBtn={handleSharePharmacyBtn}
          />
        </div>
      </div>
    );
  };

  // <===

  return (
    <div className="erx-preview-modal">
      {(loader || approveAndShareLoader) && <Loader />}
      <ErxPreviewContainerHeaderView
        handleClose={handleClose}
        handleCloseErx={handleCloseErx}
      />
      {renderPreviewMainContent()}
      <PDFDownloadLink
        document={
          <PDFViewForC2C
            erxPdfData={erxPdfData}
            lang={htmlTemplate?.languageCodeAferApiCall}
            pdfMainContent={pdfMainContent}
          />
        }
        fileName={`Prescription for Your Connect2Clinic appointment`}
      >
        {({ loading, url, blob }) =>
          loading ? <></> : <>{setTempBlob(blob)}</>
        }
      </PDFDownloadLink>
    </div>
  );
};

export default ErxPreviewContainerView;
